import "@/styles/globals.css";

import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router";

import { App } from "@/App";
import { AppToaster } from "@/components/toaster";
import { AppThemeProvider } from "@/contexts/theme";
import { queryClient } from "@/lib/api";
import { installBeaconGuard } from "@/lib/api/practice-firewall";

installBeaconGuard();

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Root element #root not found");
}

createRoot(rootElement).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <AppThemeProvider>
        <AppToaster>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </AppToaster>
      </AppThemeProvider>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  </StrictMode>,
);
